import { render, staticRenderFns } from "./subList.vue?vue&type=template&id=dfa323e6"
import script from "./subList.vue?vue&type=script&lang=js"
export * from "./subList.vue?vue&type=script&lang=js"
import style0 from "./subList.vue?vue&type=style&index=0&id=dfa323e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports